/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Home_Own_DescInputs */



/**
* | output |
* | --- |
* | "A local or national server. The bot has to be installed on it once." |
*
* @param {Tournament_Wiz_Home_Own_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_home_own_desc = /** @type {((inputs?: Tournament_Wiz_Home_Own_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Home_Own_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un serveur local ou national. Le bot doit y être installé une fois.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Un servidor local o nacional. El bot debe instalarse en él una vez.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Um servidor local ou nacional. O bot precisa ser instalado nele uma vez.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Un server locale o nazionale. Il bot va installato una volta.")
	return /** @type {LocalizedString} */ ("A local or national server. The bot has to be installed on it once.")
});